import { render } from "./marketWatchlist.vue?vue&type=template&id=7e4a2285"
import script from "./marketWatchlist.vue?vue&type=script&lang=js"
export * from "./marketWatchlist.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__